// extracted by mini-css-extract-plugin
export default {"ctnS":"Home_ctnS__rLM07","ctnT":"Home_ctnT__8mWnF","name":"Home_name__7-KwW","txt":"Home_txt__7pZOp","icon":"Home_icon__BQOEx","slidein3":"Home_slidein3__+vhgu"};